// wasm/build/wasm-module-512.js
var MLKEM512Module = (() => {
  var _scriptDir = import.meta.url;
  return (function(moduleArg = {}) {
    var Module = moduleArg;
    var readyPromiseResolve, readyPromiseReject;
    Module["ready"] = new Promise((resolve, reject) => {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
    var moduleOverrides = Object.assign({}, Module);
    var ENVIRONMENT_IS_WEB = typeof window == "object";
    var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
    var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
    var scriptDirectory = "";
    function locateFile(path) {
      return scriptDirectory + path;
    }
    var read_, readAsync, readBinary;
    if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
      if (ENVIRONMENT_IS_WORKER) {
        scriptDirectory = self.location.href;
      } else if (typeof document != "undefined" && document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }
      if (_scriptDir) {
        scriptDirectory = _scriptDir;
      }
      if (scriptDirectory.indexOf("blob:") !== 0) {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
      } else {
        scriptDirectory = "";
      }
      {
        read_ = (url) => {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, false);
          xhr.send(null);
          return xhr.responseText;
        };
        if (ENVIRONMENT_IS_WORKER) {
          readBinary = (url) => {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.responseType = "arraybuffer";
            xhr.send(null);
            return new Uint8Array(xhr.response);
          };
        }
        readAsync = (url, onload, onerror) => {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, true);
          xhr.responseType = "arraybuffer";
          xhr.onload = () => {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
              onload(xhr.response);
              return;
            }
            onerror();
          };
          xhr.onerror = onerror;
          xhr.send(null);
        };
      }
    } else {
    }
    var out = console.log.bind(console);
    var err = console.error.bind(console);
    Object.assign(Module, moduleOverrides);
    moduleOverrides = null;
    var wasmBinary;
    if (typeof WebAssembly != "object") {
      abort("no native wasm support detected");
    }
    function intArrayFromBase64(s) {
      var decoded = atob(s);
      var bytes = new Uint8Array(decoded.length);
      for (var i = 0; i < decoded.length; ++i) {
        bytes[i] = decoded.charCodeAt(i);
      }
      return bytes;
    }
    function tryParseAsDataURI(filename) {
      if (!isDataURI(filename)) {
        return;
      }
      return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }
    var wasmMemory;
    var ABORT = false;
    var EXITSTATUS;
    var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateMemoryViews() {
      var b = wasmMemory.buffer;
      Module["HEAP8"] = HEAP8 = new Int8Array(b);
      Module["HEAP16"] = HEAP16 = new Int16Array(b);
      Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
      Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
      Module["HEAP32"] = HEAP32 = new Int32Array(b);
      Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
      Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
      Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATPOSTRUN__ = [];
    var runtimeInitialized = false;
    function preRun() {
      callRuntimeCallbacks(__ATPRERUN__);
    }
    function initRuntime() {
      runtimeInitialized = true;
      callRuntimeCallbacks(__ATINIT__);
    }
    function postRun() {
      callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnInit(cb) {
      __ATINIT__.unshift(cb);
    }
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function addRunDependency(id) {
      runDependencies++;
    }
    function removeRunDependency(id) {
      runDependencies--;
      if (runDependencies == 0) {
        if (runDependencyWatcher !== null) {
          clearInterval(runDependencyWatcher);
          runDependencyWatcher = null;
        }
        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }
    function abort(what) {
      what = "Aborted(" + what + ")";
      err(what);
      ABORT = true;
      EXITSTATUS = 1;
      what += ". Build with -sASSERTIONS for more info.";
      var e = new WebAssembly.RuntimeError(what);
      readyPromiseReject(e);
      throw e;
    }
    var dataURIPrefix = "data:application/octet-stream;base64,";
    var isDataURI = (filename) => filename.startsWith(dataURIPrefix);
    var wasmBinaryFile;
    wasmBinaryFile = "data:application/octet-stream;base64,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";
    if (!isDataURI(wasmBinaryFile)) {
      wasmBinaryFile = locateFile(wasmBinaryFile);
    }
    function getBinarySync(file) {
      if (file == wasmBinaryFile && wasmBinary) {
        return new Uint8Array(wasmBinary);
      }
      var binary = tryParseAsDataURI(file);
      if (binary) {
        return binary;
      }
      if (readBinary) {
        return readBinary(file);
      }
      throw "both async and sync fetching of the wasm failed";
    }
    function getBinaryPromise(binaryFile) {
      return Promise.resolve().then(() => getBinarySync(binaryFile));
    }
    function instantiateArrayBuffer(binaryFile, imports, receiver) {
      return getBinaryPromise(binaryFile).then((binary) => WebAssembly.instantiate(binary, imports)).then((instance) => instance).then(receiver, (reason) => {
        err(`failed to asynchronously prepare wasm: ${reason}`);
        abort(reason);
      });
    }
    function instantiateAsync(binary, binaryFile, imports, callback) {
      return instantiateArrayBuffer(binaryFile, imports, callback);
    }
    function createWasm() {
      var info = { "a": wasmImports };
      function receiveInstance(instance, module) {
        wasmExports = instance.exports;
        wasmMemory = wasmExports["b"];
        updateMemoryViews();
        addOnInit(wasmExports["c"]);
        removeRunDependency("wasm-instantiate");
        return wasmExports;
      }
      addRunDependency("wasm-instantiate");
      function receiveInstantiationResult(result) {
        receiveInstance(result["instance"]);
      }
      instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
      return {};
    }
    var callRuntimeCallbacks = (callbacks) => {
      while (callbacks.length > 0) {
        callbacks.shift()(Module);
      }
    };
    function getValue(ptr, type = "i8") {
      if (type.endsWith("*")) type = "*";
      switch (type) {
        case "i1":
          return HEAP8[ptr >> 0];
        case "i8":
          return HEAP8[ptr >> 0];
        case "i16":
          return HEAP16[ptr >> 1];
        case "i32":
          return HEAP32[ptr >> 2];
        case "i64":
          abort("to do getValue(i64) use WASM_BIGINT");
        case "float":
          return HEAPF32[ptr >> 2];
        case "double":
          return HEAPF64[ptr >> 3];
        case "*":
          return HEAPU32[ptr >> 2];
        default:
          abort(`invalid type for getValue: ${type}`);
      }
    }
    function setValue(ptr, value, type = "i8") {
      if (type.endsWith("*")) type = "*";
      switch (type) {
        case "i1":
          HEAP8[ptr >> 0] = value;
          break;
        case "i8":
          HEAP8[ptr >> 0] = value;
          break;
        case "i16":
          HEAP16[ptr >> 1] = value;
          break;
        case "i32":
          HEAP32[ptr >> 2] = value;
          break;
        case "i64":
          abort("to do setValue(i64) use WASM_BIGINT");
        case "float":
          HEAPF32[ptr >> 2] = value;
          break;
        case "double":
          HEAPF64[ptr >> 3] = value;
          break;
        case "*":
          HEAPU32[ptr >> 2] = value;
          break;
        default:
          abort(`invalid type for setValue: ${type}`);
      }
    }
    var _emscripten_memcpy_js = (dest, src, num) => HEAPU8.copyWithin(dest, src, src + num);
    var wasmImports = { a: _emscripten_memcpy_js };
    var wasmExports = createWasm();
    var ___wasm_call_ctors = () => (___wasm_call_ctors = wasmExports["c"])();
    var _mlkem512_keypair_derand = Module["_mlkem512_keypair_derand"] = (a0, a1, a2) => (_mlkem512_keypair_derand = Module["_mlkem512_keypair_derand"] = wasmExports["d"])(a0, a1, a2);
    var _mlkem512_enc_derand = Module["_mlkem512_enc_derand"] = (a0, a1, a2, a3) => (_mlkem512_enc_derand = Module["_mlkem512_enc_derand"] = wasmExports["e"])(a0, a1, a2, a3);
    var _mlkem512_dec = Module["_mlkem512_dec"] = (a0, a1, a2) => (_mlkem512_dec = Module["_mlkem512_dec"] = wasmExports["f"])(a0, a1, a2);
    var ___errno_location = () => (___errno_location = wasmExports["__errno_location"])();
    var stackSave = () => (stackSave = wasmExports["h"])();
    var stackRestore = (a0) => (stackRestore = wasmExports["i"])(a0);
    var stackAlloc = (a0) => (stackAlloc = wasmExports["j"])(a0);
    Module["stackAlloc"] = stackAlloc;
    Module["stackSave"] = stackSave;
    Module["stackRestore"] = stackRestore;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    var calledRun;
    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };
    function run() {
      if (runDependencies > 0) {
        return;
      }
      preRun();
      if (runDependencies > 0) {
        return;
      }
      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module["calledRun"] = true;
        if (ABORT) return;
        initRuntime();
        readyPromiseResolve(Module);
        postRun();
      }
      {
        doRun();
      }
    }
    run();
    return moduleArg.ready;
  });
})();
var wasm_module_512_default = MLKEM512Module;

// mlkem-src/mlkem512.ts
var ALGORITHM_NAME = "ML-KEM-512";
var JWK_ALG = "MLKEM512";
var KEY_USAGES = [
  "encapsulateKey",
  "encapsulateBits",
  "decapsulateKey",
  "decapsulateBits"
];
var MlKemOperationError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "OperationError";
  }
};
var MlKemInvalidAccessError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidAccessError";
  }
};
var MlKemNotSupportedError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "NotSupportedError";
  }
};
var MlKemDataError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "DataError";
  }
};
var internalKeyData = /* @__PURE__ */ new WeakMap();
function getInternalKeyData(key) {
  const keyData = internalKeyData.get(key);
  if (!keyData) {
    throw new TypeError("Unknown key object");
  }
  return keyData;
}
var cleanupRegistry = new FinalizationRegistry((keyData) => {
  keyData.publicKeyData.fill(0);
  keyData.privateSeedData?.fill(0);
  keyData.privateSecretKeyData?.fill(0);
});
function getPublicKeyDataRef(key) {
  const keyData = getInternalKeyData(key);
  if (!keyData.publicKeyData) {
    throw new MlKemOperationError("Failed to get public key data");
  }
  return keyData.publicKeyData;
}
function getPrivateKeyDataRef(key) {
  const keyData = getInternalKeyData(key);
  if (!keyData.privateSeedData || !keyData.privateSecretKeyData) {
    throw new MlKemOperationError("Failed to get private key data");
  }
  return keyData;
}
var noClone = /* @__PURE__ */ Symbol("CryptoKey created by mlkem-wasm cannot be cloned");
var keyIdKey = "_mlkem_wasm";
var emptyToJSON = () => ({});
function createKeyObject(type, extractable, usages, keyData) {
  const key = {
    type,
    extractable,
    algorithm: Object.freeze({ name: ALGORITHM_NAME }),
    usages: Object.freeze(Array.from(usages)),
    [keyIdKey]: noClone
    // to prevent structured cloning
  };
  Object.defineProperty(key, "toJSON", {
    value: emptyToJSON,
    writable: false,
    enumerable: false,
    configurable: false
  });
  Object.setPrototypeOf(key, CryptoKey.prototype);
  internalKeyData.set(key, keyData);
  cleanupRegistry.register(key, keyData);
  return Object.freeze(key);
}
function createPublicKey(publicKeyData, usages) {
  return createKeyObject("public", true, usages, { publicKeyData });
}
function createPrivateKey(publicKeyData, privateSeedData, privateSecretKeyData, extractable, usages) {
  return createKeyObject("private", extractable, usages, {
    publicKeyData,
    privateSeedData,
    privateSecretKeyData
  });
}
function _isSupportedCryptoKey(key) {
  return key instanceof CryptoKey && keyIdKey in key && key[keyIdKey] == noClone && internalKeyData.has(key);
}
function toBase64url(data) {
  return btoa(String.fromCharCode(...data)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64url(base64url) {
  const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  const binary = atob(base64 + "===".slice((base64.length + 3) % 4));
  return Uint8Array.from(binary, (c) => c.charCodeAt(0));
}
var PUBLICKEY_BYTES = 800;
var SECRETKEY_BYTES = 1632;
var CIPHERTEXT_BYTES = 768;
var SHARED_SECRET_BYTES = 32;
var KEYPAIR_RANDOM_BYTES = 64;
var ENC_RANDOM_BYTES = 32;
var _module;
async function getModule() {
  if (!_module) {
    _module = await wasm_module_512_default();
  }
  return _module;
}
var getRandomValues = crypto.getRandomValues.bind(crypto);
function checkAlgorithm(algorithm) {
  const name = typeof algorithm === "string" ? algorithm.toUpperCase() : typeof algorithm === "object" && algorithm !== null && "name" in algorithm && typeof algorithm.name === "string" ? algorithm.name.toUpperCase() : null;
  if (name !== ALGORITHM_NAME) {
    throw new TypeError("Unsupported algorithm");
  }
}
async function internalGenerateKeyPair(coins) {
  const module = await getModule();
  const stackSave = module.stackSave();
  try {
    const pkPtr = module.stackAlloc(PUBLICKEY_BYTES);
    const skPtr = module.stackAlloc(SECRETKEY_BYTES);
    const coinsPtr = module.stackAlloc(KEYPAIR_RANDOM_BYTES);
    module.HEAPU8.set(coins, coinsPtr);
    const result = module._mlkem512_keypair_derand(pkPtr, skPtr, coinsPtr);
    if (result !== 0) {
      throw new MlKemOperationError("Key generation failed");
    }
    const rawPublicKey = new Uint8Array(PUBLICKEY_BYTES);
    const rawSecretKey = new Uint8Array(SECRETKEY_BYTES);
    const rawSeed = new Uint8Array(coins);
    rawPublicKey.set(module.HEAPU8.subarray(pkPtr, pkPtr + PUBLICKEY_BYTES));
    rawSecretKey.set(module.HEAPU8.subarray(skPtr, skPtr + SECRETKEY_BYTES));
    module.HEAPU8.fill(0, pkPtr, pkPtr + PUBLICKEY_BYTES);
    module.HEAPU8.fill(0, skPtr, skPtr + SECRETKEY_BYTES);
    module.HEAPU8.fill(0, coinsPtr, coinsPtr + KEYPAIR_RANDOM_BYTES);
    return { rawPublicKey, rawSecretKey, rawSeed };
  } finally {
    module.stackRestore(stackSave);
  }
}
async function generateKey(keyAlgorithm, extractable, usages) {
  checkAlgorithm(keyAlgorithm);
  if (!Array.isArray(usages) || usages.some((usage) => !KEY_USAGES.includes(usage))) {
    throw new SyntaxError("Invalid key usages");
  }
  const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(
    getRandomValues(new Uint8Array(KEYPAIR_RANDOM_BYTES))
  );
  const publicKey = createPublicKey(
    rawPublicKey,
    usages.filter(
      (usage) => usage === "encapsulateKey" || usage === "encapsulateBits"
    )
  );
  const privateKey = createPrivateKey(
    rawPublicKey,
    rawSeed,
    rawSecretKey,
    extractable,
    usages.filter(
      (usage) => usage === "decapsulateKey" || usage === "decapsulateBits"
    )
  );
  return {
    publicKey,
    privateKey
  };
}
async function exportKey(format, key) {
  if (!(key instanceof CryptoKey)) {
    throw new TypeError("Expected key to be an instance of CryptoKey");
  }
  checkAlgorithm(key.algorithm);
  if (!key.extractable) {
    throw new MlKemOperationError("Key is not extractable");
  }
  if (format === "spki") {
    if (key.type !== "public") {
      throw new TypeError("Expected key type to be 'public'");
    }
    return rawToDer(MLKEM512_SPKI, getPublicKeyDataRef(key)).buffer;
  }
  if (format === "pkcs8") {
    if (key.type !== "private") {
      throw new MlKemInvalidAccessError("Expected key type to be 'private'");
    }
    return rawToDer(MLKEM512_PKCS8, getPrivateKeyDataRef(key).privateSeedData).buffer;
  }
  if (format === "raw-public") {
    if (key.type !== "public") {
      throw new TypeError("Expected key type to be 'public'");
    }
    return new Uint8Array(getPublicKeyDataRef(key)).buffer;
  }
  if (format === "raw-seed") {
    if (key.type !== "private") {
      throw new MlKemInvalidAccessError("Expected key type to be 'private'");
    }
    return new Uint8Array(getPrivateKeyDataRef(key).privateSeedData).buffer;
  }
  if (format === "jwk") {
    const jwk = {
      // 2.2. Set the kty attribute of jwk to "AKP".
      kty: "AKP",
      // 2.3. Set the alg attribute of jwk to the alg value corresponding to
      // the name member of normalizedAlgorithm indicated in Section 8 of
      // [draft-ietf-jose-pqc-kem-01] (Figure 1).
      alg: JWK_ALG,
      // 2.4. Set the pub attribute of jwk to the base64url encoded public
      // key corresponding to the [[handle]] internal slot of key.
      pub: toBase64url(getPublicKeyDataRef(key))
    };
    if (key.type === "private") {
      jwk.priv = toBase64url(getPrivateKeyDataRef(key).privateSeedData);
    }
    jwk.key_ops = key.usages;
    jwk.ext = key.extractable;
    return jwk;
  }
  throw new MlKemNotSupportedError("Format not supported");
}
function bufferSourcetoUint8Array(value) {
  if (ArrayBuffer.isView(value) && value.buffer instanceof ArrayBuffer) {
    return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
  } else if (value instanceof ArrayBuffer) {
    return new Uint8Array(value);
  } else {
    throw new TypeError("Value must be a BufferSource");
  }
}
function bufferSourcetoUint8ArrayCopy(value) {
  return bufferSourcetoUint8Array(value).slice();
}
var MLKEM512_SPKI = {
  fullLength: 822,
  prefix: new Uint8Array([
    48,
    130,
    3,
    50,
    48,
    11,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    4,
    1,
    3,
    130,
    3,
    33,
    0
  ])
};
var MLKEM512_PKCS8 = {
  fullLength: 86,
  prefix: new Uint8Array([
    48,
    84,
    2,
    1,
    0,
    48,
    11,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    4,
    1,
    4,
    66,
    128,
    64
  ])
};
function bytesEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  let diff = 0;
  for (let i = 0; i < a.length; i++) {
    diff |= a[i] ^ b[i];
  }
  return diff === 0;
}
function derToRaw(encoding, der) {
  if (der.length !== encoding.fullLength) {
    throw new MlKemDataError("Invalid encoding");
  }
  const prefix = der.subarray(0, encoding.prefix.length);
  if (!bytesEqual(prefix, encoding.prefix)) {
    throw new MlKemNotSupportedError("Unsupported encoding");
  }
  return der.slice(encoding.prefix.length);
}
function rawToDer(encoding, raw) {
  const der = new Uint8Array(encoding.fullLength);
  der.set(encoding.prefix);
  der.set(raw, encoding.prefix.length);
  return der;
}
async function importKey(format, keyData, algorithm, extractable, usages) {
  checkAlgorithm(algorithm);
  if (format === "spki") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for public key");
    }
    const data = derToRaw(MLKEM512_SPKI, bufferSourcetoUint8Array(keyData));
    if (data.length !== PUBLICKEY_BYTES) {
      throw new MlKemDataError("Invalid key length");
    }
    return createPublicKey(data, usages);
  }
  if (format === "pkcs8") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "decapsulateKey" && usage !== "decapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for private key");
    }
    const data = derToRaw(MLKEM512_PKCS8, bufferSourcetoUint8Array(keyData));
    if (data.length !== KEYPAIR_RANDOM_BYTES) {
      throw new MlKemDataError("Invalid key length");
    }
    const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(data);
    return createPrivateKey(
      rawPublicKey,
      rawSeed,
      rawSecretKey,
      extractable,
      usages
    );
  }
  if (format === "raw-public") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for public key");
    }
    const data = bufferSourcetoUint8ArrayCopy(keyData);
    return createPublicKey(data, usages);
  }
  if (format === "raw-seed") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "decapsulateKey" && usage !== "decapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for private key");
    }
    const data = bufferSourcetoUint8ArrayCopy(keyData);
    if (data.length !== KEYPAIR_RANDOM_BYTES) {
      throw new MlKemDataError("Invalid key length");
    }
    const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(data);
    return createPrivateKey(
      rawPublicKey,
      rawSeed,
      rawSecretKey,
      extractable,
      usages
    );
  }
  if (format === "jwk") {
    if (typeof keyData !== "object" || keyData === null) {
      throw new MlKemDataError(
        "Expected keyData to be a JsonWebKey dictionary"
      );
    }
    const jwk = keyData;
    if (jwk.priv && usages.some(
      (usage) => usage !== "decapsulateKey" && usage !== "decapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for private key");
    }
    if (!jwk.priv && usages.some(
      (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for public key");
    }
    if (jwk.kty !== "AKP") {
      throw new MlKemDataError("Invalid key type");
    }
    if (jwk.alg !== JWK_ALG && jwk.alg !== "ML-KEM-512+A128KW") {
      throw new MlKemDataError("Invalid algorithm");
    }
    if (usages.length > 0 && jwk.use && jwk.use !== "enc") {
      throw new MlKemDataError("Invalid key usage");
    }
    if (jwk.key_ops && Array.isArray(jwk.key_ops) && !Array.prototype.every.call(
      jwk.key_ops,
      (op) => KEY_USAGES.includes(op)
    ) || !Array.isArray(jwk.key_ops)) {
      throw new MlKemDataError("Invalid key operations");
    }
    if (jwk.ext === false && extractable) {
      throw new MlKemDataError("Invalid key extractability");
    }
    if (jwk.priv) {
      try {
        const seedData = fromBase64url(jwk.priv);
        if (seedData.length !== KEYPAIR_RANDOM_BYTES) {
          throw new MlKemDataError("Invalid private key length");
        }
        const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(seedData);
        const key = createPrivateKey(
          rawPublicKey,
          rawSeed,
          rawSecretKey,
          extractable,
          usages
        );
        if (toBase64url(rawPublicKey) !== jwk.pub) {
          throw new MlKemDataError("Invalid public key data");
        }
        return key;
      } catch {
        throw new MlKemDataError("Invalid private key format");
      }
    } else {
      try {
        const publicKeyData = fromBase64url(jwk.pub);
        if (publicKeyData.length !== PUBLICKEY_BYTES) {
          throw new MlKemDataError("Invalid public key data");
        }
        return createPublicKey(publicKeyData, usages);
      } catch {
        throw new MlKemDataError("Invalid public key format");
      }
    }
  }
  throw new MlKemNotSupportedError("Unsupported key format");
}
async function getPublicKey(key, usages) {
  if (!(key instanceof CryptoKey)) {
    throw new TypeError("Expected key to be an instance of CryptoKey");
  }
  checkAlgorithm(key.algorithm);
  if (key.type !== "private") {
    throw new MlKemInvalidAccessError("Expected key type to be 'private'");
  }
  if (!Array.isArray(usages) || usages.some(
    (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
  )) {
    throw new SyntaxError("Invalid key usages");
  }
  const keyData = getInternalKeyData(key);
  if (!keyData.publicKeyData) {
    throw new MlKemOperationError("Failed to get public key data");
  }
  return createPublicKey(new Uint8Array(keyData.publicKeyData), usages);
}
async function internalEncapsulate(algorithm, encapsulationKey, usage) {
  const module = await getModule();
  checkAlgorithm(algorithm);
  if (!(encapsulationKey instanceof CryptoKey) || encapsulationKey.type !== "public") {
    throw new MlKemInvalidAccessError(
      "Expected publicKey to be an instance of MlKemCryptoKey with type 'public'"
    );
  }
  if (!encapsulationKey.usages.includes(usage)) {
    throw new MlKemInvalidAccessError(`Key usages don't include '${usage}'`);
  }
  const publicKeyData = getPublicKeyDataRef(encapsulationKey);
  if (publicKeyData.length !== PUBLICKEY_BYTES) {
    throw new MlKemOperationError("Invalid public key length");
  }
  const coins = getRandomValues(new Uint8Array(ENC_RANDOM_BYTES));
  const stackSave = module.stackSave();
  try {
    const pkPtr = module.stackAlloc(PUBLICKEY_BYTES);
    const ctPtr = module.stackAlloc(CIPHERTEXT_BYTES);
    const ssPtr = module.stackAlloc(SHARED_SECRET_BYTES);
    const coinsPtr = module.stackAlloc(ENC_RANDOM_BYTES);
    module.HEAPU8.set(publicKeyData, pkPtr);
    module.HEAPU8.set(coins, coinsPtr);
    const result = module._mlkem512_enc_derand(ctPtr, ssPtr, pkPtr, coinsPtr);
    if (result !== 0) {
      throw new MlKemOperationError("Encapsulation failed");
    }
    const ciphertext = new Uint8Array(CIPHERTEXT_BYTES);
    const sharedKey = new Uint8Array(SHARED_SECRET_BYTES);
    ciphertext.set(module.HEAPU8.subarray(ctPtr, ctPtr + CIPHERTEXT_BYTES));
    sharedKey.set(module.HEAPU8.subarray(ssPtr, ssPtr + SHARED_SECRET_BYTES));
    module.HEAPU8.fill(0, ctPtr, ctPtr + CIPHERTEXT_BYTES);
    module.HEAPU8.fill(0, ssPtr, ssPtr + SHARED_SECRET_BYTES);
    module.HEAPU8.fill(0, pkPtr, pkPtr + PUBLICKEY_BYTES);
    module.HEAPU8.fill(0, coinsPtr, coinsPtr + ENC_RANDOM_BYTES);
    return {
      ciphertext: ciphertext.buffer,
      sharedKey: sharedKey.buffer
    };
  } finally {
    module.stackRestore(stackSave);
  }
}
async function encapsulateBits(algorithm, encapsulationKey) {
  return internalEncapsulate(algorithm, encapsulationKey, "encapsulateBits");
}
async function encapsulateKey(encapsulationAlgorithm, encapsulationKey, sharedKeyAlgorithm, extractable, usages) {
  const { sharedKey: sharedKeyBits, ciphertext } = await internalEncapsulate(
    encapsulationAlgorithm,
    encapsulationKey,
    "encapsulateKey"
  );
  const sharedKey = await crypto.subtle.importKey(
    "raw",
    sharedKeyBits,
    sharedKeyAlgorithm,
    extractable,
    usages
  );
  return {
    sharedKey,
    ciphertext
  };
}
async function internalDecapsulate(algorithm, decapsulationKey, ciphertext, usage) {
  const module = await getModule();
  checkAlgorithm(algorithm);
  if (!(decapsulationKey instanceof CryptoKey) || decapsulationKey.type !== "private") {
    throw new MlKemInvalidAccessError(
      "Expected key to be an instance of MlKemCryptoKey with type 'private'"
    );
  }
  if (!decapsulationKey.usages.includes(usage)) {
    throw new MlKemInvalidAccessError(`Key usages don't include '${usage}'`);
  }
  const secretKeyData = getPrivateKeyDataRef(decapsulationKey).privateSecretKeyData;
  if (!secretKeyData || secretKeyData.length !== SECRETKEY_BYTES) {
    throw new Error("Invalid secret key length");
  }
  const ct = bufferSourcetoUint8Array(ciphertext);
  if (ct.length !== CIPHERTEXT_BYTES) {
    throw new MlKemOperationError("Invalid ciphertext length");
  }
  const stackSave = module.stackSave();
  try {
    const ctPtr = module.stackAlloc(CIPHERTEXT_BYTES);
    const skPtr = module.stackAlloc(SECRETKEY_BYTES);
    const ssPtr = module.stackAlloc(SHARED_SECRET_BYTES);
    module.HEAPU8.set(ct, ctPtr);
    module.HEAPU8.set(secretKeyData, skPtr);
    const result = module._mlkem512_dec(ssPtr, ctPtr, skPtr);
    if (result !== 0) {
      throw new MlKemOperationError("Decapsulation failed");
    }
    const sharedKey = new Uint8Array(SHARED_SECRET_BYTES);
    sharedKey.set(module.HEAPU8.subarray(ssPtr, ssPtr + SHARED_SECRET_BYTES));
    module.HEAPU8.fill(0, ctPtr, ctPtr + CIPHERTEXT_BYTES);
    module.HEAPU8.fill(0, skPtr, skPtr + SECRETKEY_BYTES);
    module.HEAPU8.fill(0, ssPtr, ssPtr + SHARED_SECRET_BYTES);
    return sharedKey.buffer;
  } finally {
    module.stackRestore(stackSave);
  }
}
async function decapsulateBits(decapsulationAlgorithm, decapsulationKey, ciphertext) {
  return internalDecapsulate(
    decapsulationAlgorithm,
    decapsulationKey,
    ciphertext,
    "decapsulateBits"
  );
}
async function decapsulateKey(decapsulationAlgorithm, decapsulationKey, ciphertext, sharedKeyAlgorithm, extractable, usages) {
  const sharedKeyBits = await internalDecapsulate(
    decapsulationAlgorithm,
    decapsulationKey,
    ciphertext,
    "decapsulateKey"
  );
  const sharedKey = await crypto.subtle.importKey(
    "raw",
    sharedKeyBits,
    sharedKeyAlgorithm,
    extractable,
    usages
  );
  return sharedKey;
}
var mlkem = {
  generateKey,
  exportKey,
  importKey,
  getPublicKey,
  encapsulateBits,
  encapsulateKey,
  decapsulateBits,
  decapsulateKey,
  _isSupportedCryptoKey
};
var mlkem512_default = mlkem;
export {
  mlkem512_default as default
};
